import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { createForm } from 'rc-form';
import { Switch } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import PrivateRoute from 'yeself-client-common/security/components/PrivateRoute';

import NavSider from 'Console/components/accounts/detail/settings/NavSider';
import Breadcrumb from 'Console/components/common/Breadcrumb';
import General from 'Console/components/accounts/detail/settings/general/General';
import BillingUpdate from 'Console/components/accounts/detail/settings/billingUpdate/BillingUpdate';
import CreateSubscription from 'Console/components/accounts/detail/settings/createSubscription/CreateSubscription';
import Billing from 'Console/components/accounts/detail/settings/billing/Billing';
import Invoices from 'Console/components/accounts/detail/settings/invoices/Invoices';

import { ROUTES } from 'Console/constants/routes';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
    },
    navLink: {
        textDecoration: 'none',
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    navList: {
        [theme.breakpoints.up('lg')]: {
            maxWidth: '18%',
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: '15%',
        },
        [theme.breakpoints.down('md')]: {
            marginBottom: '20px',
        },
    },
    formBox: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '83%',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '82%',
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: '85%',
        },
    },
});

const AccountsSettings = ({ classes, intl, hasGlobalRoutePrefix = false, form, match, ...props }) => {
    const routePrefix = hasGlobalRoutePrefix ? ROUTES.SETTINGS : match.url;

    return (
        <Grid container className={classes.root}>
            <Switch>
                <>
                    <Grid container spacing={24} justify="center" alignItems="center">
                        <Grid item xs={12} md={hasGlobalRoutePrefix ? 10 : 12}>
                            <Breadcrumb
                                paths={[
                                    {
                                        to: ROUTES.ACCOUNTS,
                                        text: intl.formatMessage({ id: 'Navigation.accounts' }),
                                    },
                                    {
                                        text: 'Account name',
                                    },
                                ]}
                            />

                            <Typography variant="h6">
                                {intl.formatMessage({ id: 'Navigation.settings' })}
                            </Typography>
                        </Grid>
                        <Grid item container xs={12} md={hasGlobalRoutePrefix ? 10 : 12}>
                            <Grid item xs={12} md={2} className={classes.navList}>
                                <NavSider intl={intl} routePrefix={routePrefix} />
                            </Grid>

                            <Grid item xs={12} className={classes.formBox}>
                                <Switch>
                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.SETTINGS_GENERAL}`}
                                        component={General}
                                    />
                                    {/* <PrivateRoute
                                    path={`${routePrefix}${ROUTES.SETTINGS_PASSWORD}`}
                                    component={Password}
                                    form={form}
                                /> */}
                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.SETTINGS_BILLING}`}
                                        component={Billing}
                                    />
                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.SETTINGS_INVOICES}`}
                                        component={Invoices}
                                    />

                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.SETTINGS_BILLING_UPDATE}`}
                                        component={BillingUpdate}
                                    />
                                    <PrivateRoute
                                        path={`${routePrefix}${ROUTES.CREATE_SUBSCRIPTION}`}
                                        component={CreateSubscription}
                                    />
                                </Switch>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            </Switch>
        </Grid>
    );
};

export default withStyles(styles)(injectIntl(createForm({ preserve: true })(AccountsSettings)));
